<script setup>
import { inject } from 'vue'

const store = inject('store');

</script>

<template>
  <h3 class="display-5 text-uppercase text-grey mb-4">Timetable</h3>

  <div class="row">
    <div class="col-sm-12 bg-black">
      <div class="table-responsive pt-3 text-center">
        <table class="table table-bordered table-dark table-sm text-uppercase border-secondary align-middle">
          <thead>
            <tr class="bg-black">
              <th class="bg-black"><a href="https://www.timeanddate.com/worldclock/uk/london" target="_blank" title="London time" class="text-decoration-none text-grey">Course time &middot; UK &#8986;</a></th>
              <th class="bg-black text-grey">Mon</th>
              <th class="bg-black text-grey">Tue</th>
              <th class="bg-black text-grey">Wed</th>
              <th class="bg-black text-grey">Thu</th>
              <th class="bg-black text-grey">Fri</th>
              <th class="bg-black text-grey">Sat</th>
              <th class="bg-black text-grey">Sun</th>
            </tr>
          </thead>
          <tbody>        
            <tr v-for="(daily, index) of store.state.timetable" :key="index">
              <th class="bg-black">
                <div class="d-flex justify-content-center">
                  <img v-for="(item, index) of daily.thumbnails" :key="index" width="100" height="auto" :src="require(`../assets/${item}`)" class="me-2 mb-2" :alt="daily.name"  />
                </div>
                <span class="badge bg-secondary text-black">{{ daily.level }}</span>
              </th>
              <td class="bg-black" title="X">
                <span class="badge text-bg-warning">{{ daily.mon }}</span>
              </td>
              <td class="bg-black" title="X">
                <span class="badge text-bg-warning">{{ daily.tue }}</span>
              </td>
              <td class="bg-black" title="Y">
                <span class="badge text-bg-primary">{{ daily.wed }}</span>
              </td>
              <td class="bg-black" title="Y">
                <span class="badge text-bg-primary">{{ daily.thu }}</span>
              </td>
              <td class="bg-black" title="Z">
                <span class="badge text-bg-danger">{{ daily.fri }}</span>
              </td>
              <td class="bg-black" title="Z">
                <span class="badge text-bg-danger">{{ daily.sat }}</span>
              </td>
              <td class="bg-black" title="O">
                <span class="badge text-bg-light">{{ daily.sun }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th class="bg-black"><a href="https://www.timeanddate.com/worldclock/uk/london" target="_blank" title="London time" class="text-decoration-none text-grey">Course time &middot; UK &#8986;</a></th>
              <th class="bg-black text-grey">Mon</th>
              <th class="bg-black text-grey">Tue</th>
              <th class="bg-black text-grey">Wed</th>
              <th class="bg-black text-grey">Thu</th>
              <th class="bg-black text-grey">Fri</th>
              <th class="bg-black text-grey">Sat</th>
              <th class="bg-black text-grey">Sun</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>